









































































































































































import {Component, Vue} from 'vue-property-decorator';
import Loading from '@c/controls/Loading.vue';
import IconButton from '@c/controls/IconButton.vue';
import SimpleDialog from '@c/SimpleDialog.vue';
import DeleteDialog from '@c/DeleteDialog.vue';
import CancelChangesDialog from '@c/CancelChangesDialog.vue';
import router from '@/router';
import measurementsStoreModule from '@/store/modules/entities/measurementsModule';
import bearingtasksStoreModule from '@/store/modules/bearingtasksModule';
import diagtaskModule from '@/store/modules/diagtaskModule';
import {BearingTasksTableHeader} from './interfaces';

@Component({
  components: {
    IconButton,
    CancelChangesDialog,
    SimpleDialog,
    DeleteDialog,
    Loading,
  },
})
export default class BearingTasks extends Vue {
  loading = false;
  saving = false;
  error = false;

  valid = true;

  measurementEditDialog = false;
  currentMeasurementIdx = -1;
  currentMeasurementId: number | null = null;
  currentTopWarningBoundary: number | null = null;
  currentTopDangerBoundary: number | null = null;
  currentTopErrorBoundary: number | null = null;
  currentBottomWarningBoundary: number | null = null;
  currentBottomDangerBoundary: number | null = null;
  currentBottomErrorBoundary: number | null = null;

  measurementsHeaders: BearingTasksTableHeader[] = [
    {
      text: 'Описание',
      value: 'measurementDescription',
      sortable: true,
    },
    {
      text: 'В.гр.предупреждения',
      value: 'topWarningBoundary',
      sortable: false,
    },
    {
      text: 'В.гр.опасного значения',
      value: 'topDangerBoundary',
      sortable: false,
    },
    {
      text: 'В.гр.ошибки',
      value: 'topErrorBoundary',
      sortable: false,
    },
    {
      text: 'Н.гр.предупреждения',
      value: 'bottomWarningBoundary',
      sortable: false,
    },
    {
      text: 'Н.гр.опасного значения',
      value: 'bottomDangerBoundary',
      sortable: false,
    },
    {
      text: 'Н.гр.ошибки',
      value: 'bottomErrorBoundary',
      sortable: false,
    },
    {
      text: 'Действия',
      value: 'actions',
      sortable: false,
      width: 90,
    },
  ];

  bearingtask: any = [];
  span_nodes: any = [];
  measurements_list: any = [];

  nonEmptyTextRule = (v: any) => !!v || (v && v.length === 0) || 'Поле обязательно для заполнения';
  RegExPattern = /^([0-9A-Fa-f]{12})$/;
  nonEmptyNumberRule = (v: any) => v != null || 'Поле обязательно для заполнения';
  nonNegativeNumberRule = (v: any) => v >= -1 || 'Поле должно быть неотрицательным числом';
  integerNumberRule = (v: any) => Number.isInteger(Number(v)) || 'Поле должно быть целым числом';

  async onSave() {
    const err_container = this.$refs.err_text as any;
    this.valid = await (this.$refs.form as any).validate();
    if (!this.valid) {
      const error = document.querySelector('div.error--text');
      error && this.$vuetify.goTo(error as HTMLElement);
      return;
    }
    if (err_container) err_container.innerText = 'Обрабатываю...';
    try {
      await bearingtasksStoreModule.save(this.bearingtask);
    } catch (err) {
      console.log(err);
      if (err_container) err_container.innerText = 'Ошибка обновления: ' + err;
      return;
    }
    if (err_container) err_container.innerText = '';
    router.push('/bearingtasks');
  }

  //переменная, сигнализирующая о внесенных и несохраненных изменениях на форме
  changed = false;

  // Действия при изменении поля
  async onChange() {
    this.changed = true;
  }

  async created() {
    this.loading = true;
    await measurementsStoreModule.fetchAll();
    this.measurements_list = measurementsStoreModule.entities.filter(
      (ms: any) => ms.moduleType == 'BearingTasks',
    );
    await diagtaskModule.fetchAll();
    this.span_nodes = diagtaskModule.all;
    const bearingtaskId = this.$router.currentRoute.params.id;
    if (bearingtaskId) {
      const {data} = await bearingtasksStoreModule.getById(bearingtaskId);
      this.bearingtask = data;
    } else {
      this.bearingtask = await bearingtasksStoreModule.create();
    }
    this.loading = false;
  }

  get cancelChangesDialog() {
    return this.$refs.cancelChangesDialog as any;
  }

  back() {
    // если были внесены изменения на форме
    if (this.changed) {
      this.cancelChangesDialog.open('/bearingtasks');
    } else router.push('/bearingtasks');
  }

  diagtask(id: number) {
    if (!id) return;
    const {href} = this.$router.resolve({
      name: 'EditDiagTask',
      params: {id: `${id}`},
    });
    window.open(href, '_blank');
  }

  addMeasurement() {
    this.currentMeasurementIdx = -1;
    this.currentMeasurementId = -1;
    this.currentTopWarningBoundary = null;
    this.currentTopDangerBoundary = null;
    this.currentTopErrorBoundary = null;
    this.currentBottomWarningBoundary = null;
    this.currentBottomDangerBoundary = null;
    this.currentBottomErrorBoundary = null;
    this.measurementEditDialog = true;
  }

  editMeasurement(item: any) {
    this.currentMeasurementIdx = this.bearingtask.measurements.indexOf(item);
    this.currentMeasurementId = item.measurementId;
    this.currentTopWarningBoundary = item.topWarningBoundary;
    this.currentTopDangerBoundary = item.topDangerBoundary;
    this.currentTopErrorBoundary = item.topErrorBoundary;
    this.currentBottomWarningBoundary = item.bottomWarningBoundary;
    this.currentBottomDangerBoundary = item.bottomDangerBoundary;
    this.currentBottomErrorBoundary = item.bottomErrorBoundary;
    this.measurementEditDialog = true;
  }

  deleteMeasurement(item: any) {
    const index = this.bearingtask.measurements.indexOf(item);
    const deleteDialog = this.$refs.deleteDialog as any;
    const itemName: string = item.measurementDescription;
    deleteDialog.open(
      {index, itemName},
      {
        deleteCallback: async (elem: any) => {
          deleteDialog.close();
          this.bearingtask.measurements.splice(elem, 1);
        },
      },
    );
  }

  measurementSettingsChanged() {
    if (this.currentMeasurementIdx >= 0) {
      this.bearingtask.measurements[
        this.currentMeasurementIdx
      ].measurementId = this.currentMeasurementId;
      this.bearingtask.measurements[
        this.currentMeasurementIdx
      ].measurementDescription = this.measurements_list.find(
        (m: any) => m.id == this.currentMeasurementId,
      ).name;
      this.bearingtask.measurements[
        this.currentMeasurementIdx
      ].topWarningBoundary = this.currentTopWarningBoundary;
      this.bearingtask.measurements[
        this.currentMeasurementIdx
      ].topDangerBoundary = this.currentTopDangerBoundary;
      this.bearingtask.measurements[
        this.currentMeasurementIdx
      ].topErrorBoundary = this.currentTopErrorBoundary;
      this.bearingtask.measurements[
        this.currentMeasurementIdx
      ].bottomWarningBoundary = this.currentBottomWarningBoundary;
      this.bearingtask.measurements[
        this.currentMeasurementIdx
      ].bottomDangerBoundary = this.currentBottomDangerBoundary;
      this.bearingtask.measurements[
        this.currentMeasurementIdx
      ].bottomErrorBoundary = this.currentBottomErrorBoundary;
    } else {
      this.bearingtask.measurements.push({
        measurementId: this.currentMeasurementId,
        measurementDescription: this.measurements_list.find(
          (m: any) => m.id == this.currentMeasurementId,
        ).name,
        topWarningBoundary: this.currentTopWarningBoundary,
        topDangerBoundary: this.currentTopDangerBoundary,
        topErrorBoundary: this.currentTopErrorBoundary,
        bottomWarningBoundary: this.currentBottomWarningBoundary,
        bottomDangerBoundary: this.currentBottomDangerBoundary,
        bottomErrorBoundary: this.currentBottomErrorBoundary,
      });
    }
    this.measurementEditDialog = false;
  }
}
